import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "typeface-amiri";
import { useAuth } from "./AuthContext";
import ChatWrapper from "./components/ChatWrapper";
import Layout from "./components/Layout";
import BookingPage from "./pages/auth/client/BookingPage";
import DashboardClient from "./pages/auth/client/Dashboard";
import Login from "./pages/auth/Login";
import Profile from "./pages/auth/Profile";
import Register from "./pages/auth/Register";
import Account from "./pages/auth/users_worker/Account";
import AppointmentsPage from "./pages/auth/users_worker/AppointmentsPage";
import DashboardWorkusers from "./pages/auth/users_worker/Dashboard";
import Messages from "./pages/auth/users_worker/Messages";
import Planning from "./pages/auth/users_worker/Planning";
import Tablework from "./pages/auth/users_worker/Table_work";
import MunicipalityUsers from "./pages/MunicipalityUsers";
import ProfileLayout from "./pages/ProfileLayout";
import ServicePage from "./pages/ServicePage";
import VerifyOtp from "./pages/VerifyEmail";
import Welcome from "./pages/Welcome";
import ProtectedRoute from "./ProtectedRoute";

function App() {
  const { loading } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "100px",
        }}
      >
        <ClipLoader color="#36d7b7" />
      </div>
    );
  }
  return (
    <Routes>
      <Route
        path="/"
        element={(() => {
          const userStr = localStorage.getItem("user");
          const token = localStorage.getItem("token");

          if (!token || !userStr) return <Welcome />;

          let user = null;
          try {
            user = JSON.parse(userStr);
          } catch {
            return <Welcome />;
          }

          if (user?.role === "client")
            return <Navigate to="/dashboard-Client" replace />;
          if (user?.role === "worker")
            return <Navigate to="/dashboard-usersWorks" replace />;

          return <Welcome />;
        })()}
      />

      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify-otp" element={<VerifyOtp />} />

      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard-Client" element={<DashboardClient />} />
        <Route path="/services/:serviceName" element={<ServicePage />} />
        <Route
          path="/municipality/:serviceName/:baladiya"
          element={<MunicipalityUsers />}
        />
        <Route path="/booking/:serviceName/:userId" element={<BookingPage />} />

        <Route path="/chat/:receiverId" element={<ChatWrapper />} />

        <Route element={<ProfileLayout />}>
          <Route path="/profile" element={<Profile />} />
        </Route>

        <Route element={<Layout />}>
          <Route
            path="/dashboard-usersWorks"
            element={<DashboardWorkusers />}
          />
          <Route path="/planning" element={<Planning />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/account" element={<Account />} />
          <Route path="/tablework" element={<Tablework />} />
          <Route path="/appointments" element={<AppointmentsPage />} />
        </Route>
      </Route>

      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
}

export default function RootApp() {
  return (
    <BrowserRouter>
      <App />
      <ToastContainer position="top-right" autoClose={3000} />
    </BrowserRouter>
  );
}
